import React from "react";
import EntitySelector from "./index";

const CompanySelector = ({
                           allCompanies,
                           selectedCompanyId,
                           onCompanyChange,
                           loading,
                           disabled
                         }) => {
  return (
    <EntitySelector
      entities={allCompanies}
      selectedEntityId={selectedCompanyId}
      onEntityChange={onCompanyChange}
      loading={loading}
      disabled={disabled}
      placeholder="Select a Company"
      icon="business"
      loadingText="Loading companies..."
      emptyResultText="No companies found"
    />
  );
};

export default CompanySelector;